module.exports = __webpack_public_path__ + "media/תפוח.ecd68455.mp3";